<script setup>
import {ref, onMounted, computed} from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
import { useStore } from 'vuex';
import axios from "axios";
const store = useStore();
const productId = computed(() => store.getters.getProductId);
const guid = computed(() => store.getters.getGuid);
const qq = computed(() => store.getters.getQq);
const list = ref([]);
onMounted(() => {
  const queryData = {
    productId: productId.value,
    guid: guid.value,
  };
  if (qq.value !== '') {
    queryData.qq = qq.value;
  }

  axios.get('/feedback',{ params: queryData }).then(res => {
    if (res.data && res.data.content) {
      res.data.content.forEach(item => {
        item.createTime = (new Date(item.createTime)).toLocaleDateString()
            .replace(/\//gi, '-');
      });
      list.value = res.data.content;
      console.log('my feedbacks', res.data);
    } else {
      console.error('Invalid response data:', res.data);
    }
  }).catch(err => {
    console.log(err);
  });
});
const goDetail = (item) => {
  router.push({ path: `/myDetail`, query: item });
}
const goToFeedback = (item) => {
  router.push({ path: '/feedback' });
};
</script>

<template>
  <div class="content-box" v-if="list.length > 0">
    <div v-for="item in list" class="item" @click="goDetail(item)">
      <p class="content">{{item.content}}</p>
      <span class="time">{{item.createTime}} 提交</span>
      <div class="message-indicator" v-if="item.readStatus > 0"></div>
    </div>
  </div>
  <div class="no-result" v-else>
    <div class="image-container">
      <img src="../assets/no-result.png" alt="No Result" class="no-result-image">
      <span class="image-text">您还没有反馈过哦</span>
    </div>
    <button class="feedback-button" @click="goToFeedback">我要反馈</button>
  </div>

</template>

<style scoped lang="scss">
@import '~/entries/index/index.scss';
.content-box {
  background: rgba(245, 248, 253, 1);
  min-height: 100%;
  padding-top: 24 * $px;
  padding-bottom: 24 * $px;

  .item {
    height: 138 * $px;
    width: 630 * $px;
    background: white;
    border-radius: 14 * $px;
    padding: 28 * $px 36 * $px;
    margin: 0 24 * $px 24 * $px 24 * $px;
    position: relative;
    .content {
      font-size: 28 * $px;
      line-height: 32 * $px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      margin-bottom: 0;
    }
    .time {
      font-size: 20 * $px;
      line-height: 28 * $px;
      color: rgba(188, 188, 188, 1);
    }
    .message-indicator {
      position: absolute;
      top: 30 * $px;
      right: 30 * $px;
      width: 12 * $px;
      height: 12 * $px;
      background-color: red;
      border-radius: 50%;
    }
  }
}
.no-result {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .image-container {
    position: relative;
    display: inline-block;
    .no-result-image {
      width: 301 * $px;
      height: 301 * $px;
    }
    .image-text {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      font-size: 18 * $px;
      line-height: 33.6 * $px;
      color: rgba(136, 136, 136, 1);
    }
  }
}

.feedback-button {
  margin-top: 30 * $px; /* 按钮与图片之间的间距 */
  width: 217 * $px;
  height: 79 * $px;
  background: rgba(231, 235, 255, 1);
  border: none;
  border-radius: 36 * $px;
  font-size: 28 * $px;
  line-height: 39.2 * $px;
  color: rgba(75, 106, 255, 1);
}
</style>
